import { LegalBase, ILegalBase } from './LegalBase';
import { ConsentSource, IConsentSource } from './ConsentSource';
import { ConsentSubscription, IConsentSubscription } from './ConsentSubscription';
import { User } from '../User/User';

export interface IConsent {
    id?: number;
    title: string;
    description: string;
    htmlIsUrl: boolean;
    html: string;

    dateCreated?: Date;
    dateLastChanged?: Date;
    dateDeleted?: Date;
    deleted?: boolean;

    legalBaseId?: number;
    legalBase?: ILegalBase;
    consentSourceId?: number;
    consentSource?: IConsentSource;

    createdById?: number;
    createdBy?: User;
    updatedById?: number;
    updatedBy?: User;

    consentSubscriptions: IConsentSubscription[];
}

export class Consent implements IConsent {
    id?: number;
    title: string;
    description: string;
    htmlIsUrl: boolean;
    html: string;

    dateCreated?: Date;
    dateLastChanged?: Date;
    dateDeleted?: Date;
    deleted?: boolean;

    legalBaseId?: number;
    legalBase?: ILegalBase;
    consentSourceId?: number;
    consentSource?: IConsentSource;

    createdById?: number;
    createdBy?: User;
    updatedById?: number;
    updatedBy?: User;

    consentSubscriptions: IConsentSubscription[];

    constructor(){
    }
}